import React, { useContext, useEffect, useState } from 'react'
import TextItems from 'modules/react/loan-calculator/content/TextItems'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import useFormat from 'modules/react/loan-calculator/hooks/useFormat'
import LoanTextItem from 'modules/react/loan-calculator/content/LoanTextItem'

const LoanCalculations = () => {
  const { productDataObject, loanCalculationObject, interestTypeValue, tooltips } = useContext(LoanCalculatorContext)
  const { formatPrice, formatPercentWithDecimal } = useFormat()
  const { loanCalculationData } = loanCalculationObject
  const { productData } = productDataObject
  const { interestRateRangeFixed, interestRateRangeVariable } = productData || {}
  const [interestRate, setInterestRate] = useState(undefined)

  useEffect(() => {
    interestTypeValue === 'Fixed'
      ? setInterestRate(interestRateRangeFixed?.defaultValue)
      : setInterestRate(interestRateRangeVariable?.defaultValue)
  }, [interestTypeValue])

  return (
    <TextItems>
      <LoanTextItem
        title='ÅOP'
        value={formatPercentWithDecimal(loanCalculationData?.apr)}
        tooltip={tooltips.tooltip1}
      />
      <LoanTextItem
        title='Hovedstol'
        value={formatPrice(loanCalculationData?.financingAmount)}
        tooltip={tooltips.tooltip2}
      />
      <LoanTextItem
        title='Samlede kreditomkostninger'
        value={formatPrice(loanCalculationData?.totalCreditPayments)}
        tooltip={tooltips.tooltip3}
      />
      <LoanTextItem
        title='Årlig rente i procent'
        value={formatPercentWithDecimal(interestRate)}
        tooltip={tooltips.tooltip4}
      />
      <LoanTextItem
        title='Stiftelsesomkostninger'
        value={formatPrice(loanCalculationData?.creditCosts)}
        tooltip={tooltips.tooltip5}
      />
      <LoanTextItem
        title='Samlede beløb der skal betales'
        value={formatPrice(loanCalculationData?.totalRepaymentInclUpfrontPayment)}
        tooltip={tooltips.tooltip6}
      />
    </TextItems>
  )
}

export default LoanCalculations
